import { initSwiperSlider, destroySwiperSlider } from '@theme/utilities';
import { Navigation } from '@theme/swiper-modules';

class MediaGallerySlider extends HTMLElement {
  connectedCallback() {
    if (window.innerWidth >= 768) return;

    const slidesPerView = parseInt(this.dataset.slidesPerView, 10) || 1;
    const spaceBetween = parseInt(this.dataset.spaceBetween, 10) || 0;
    const loop = this.dataset.loop === 'true';

    this._swiper = initSwiperSlider(this, {
      containerSelector: '.media-gallery-slider__swiper',
      prevSelector: '.media-gallery-slider__prev',
      nextSelector: '.media-gallery-slider__next',
      swiperOptions: {
        modules: [Navigation],
        slidesPerView,
        spaceBetween,
        loop
      },
    });
  }

  disconnectedCallback() {
    destroySwiperSlider(this, {
      containerSelector: '.media-gallery-slider__swiper',
    });
  }
}

if (!customElements.get('media-gallery-slider')) {
  customElements.define('media-gallery-slider', MediaGallerySlider);
}
